/**
 * The optin types available:
 * @example
 * - OPTIN_TYPE_DEFAULT: 0
 * - OPTIN_TYPE_RECURRING_NOTIF_MESSENGER: 1
 * - OPTIN_TYPE_RECURRING_NOTIF_INSTAGRAM: 2
 */
export enum OptinTypeEnum {
  OPTIN_TYPE_DEFAULT,
  OPTIN_TYPE_RECURRING_NOTIF_MESSENGER,
  OPTIN_TYPE_RECURRING_NOTIF_INSTAGRAM,
}
